<!-- 嵌入式-维修登记 -->
<template>
  <el-card>
    <div class="toolbar">
      <el-button type="primary" @click="onCreateItem()">
        <i class="fas fa-plus"></i> 新增维修记录
      </el-button>
      <div class="former">
        <el-input
          v-model.trim="key"
          placeholder="名称、SN或送修来源"
          @keydown.enter.native="onSubmitQuery"
        >
        </el-input
        >&nbsp;
        <el-select v-model="former.Type" clearable placeholder="维修类型">
          <el-option label="产品" :value="0"></el-option>
          <el-option label="配件" :value="1"></el-option> </el-select
        >&nbsp;
        <select2
          labelName="Name"
          v-model="former.DealPeopleID"
          url="user"
          clearable
          placeholder="处理人"
          no-data-text="没有处理人"
        ></select2
        >&nbsp;
        <select2
          labelName="Value"
          valueKey="Key"
          v-model="former.DealStatus"
          url="dci/maintain/status-list"
          clearable
          placeholder="维修状态"
          no-data-text="没有维修状态"
        ></select2
        >&nbsp;
        <el-button type="primary" @click="onSubmitQuery">
          <i class="fas fa-search"></i>
        </el-button>
      </div>
    </div>
    <el-table :data="itemList" v-loading="loading" size="medium">
      <el-table-column
        type="index"
        :index="pager.size * (pager.page - 1) + 1"
        :width="Math.max(40, (pager.size * pager.page).toString().length * 12)"
      />
      <el-table-column label="类型" width="70">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.Type === 0" type="warning"> 产品 </el-tag>
          <el-tag v-if="scope.row.Type === 1" type="success"> 配件 </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="产品/配件型号名称" width="200">
        <template slot-scope="scope">
          <div v-if="scope.row.DciProduct !== null">
            {{ scope.row.DciProduct.DciProductModel.NameNumber }}
          </div>
          <div v-if="scope.row.DciAccessory !== null">
            {{ scope.row.DciAccessory.DciAccessoryModel.NameNumber }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="产品/配件SN" width="190">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.DciProduct !== null">
            {{ scope.row.DciProduct.SN }}
          </el-tag>
          <el-tag
            type="success"
            v-if="
              scope.row.DciProduct !== null &&
              scope.row.DciProduct.Remark !== ''
            "
          >
            {{ scope.row.DciProduct.Remark }}
          </el-tag>
          <el-tag v-if="scope.row.DciAccessory !== null">
            {{ scope.row.DciAccessory.SN }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="送修来源">
        <template slot-scope="scope">
          {{ scope.row.SendSource }}
          <el-tooltip
            content="Top center"
            placement="top"
            effect="light"
            v-if="scope.row.AmbSaleOrderCode !== ''"
          >
            <div slot="content">报价单：{{scope.row.AmbSaleOrderCode}}</div>
            <i
              class="fas fa-file"
              style="color: #67c23a; cursor: pointer"
              @click="onShowSaleOrder(scope.row)"
            ></i>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="送修日期" width="100">
        <template slot-scope="scope">
          <div v-if="scope.row.SendAt">
            {{ $sys.dateFormat(scope.row.SendAt, "Y-m-d") }}
          </div>
        </template>
      </el-table-column>
      <el-table-column width="140">
        <template slot="header" slot-scope="scope">
          <div
            style="padding-left: 0px; padding-right: 0px; line-height: normal"
          >
            期望初检完成日期
          </div>
          <div
            style="
              padding-left: 0px;
              padding-right: 0px;
              line-height: normal;
              margin-top: -5px;
            "
          >
            期望维修完成日期
          </div>
        </template>
        <template slot-scope="scope">
          <div
            v-if="
              scope.row.ExpectedInspectAt &&
              new Date(scope.row.ExpectedInspectAt).getTime() <=
                new Date(new Date()).getTime() &&
              (scope.row.DealStatus === 0 ||
                scope.row.DealStatus === 1 ||
                scope.row.DealStatus === 2)
            "
            style="color: red"
          >
            {{ $sys.dateFormat(scope.row.ExpectedInspectAt, "Y-m-d H:i") }}
          </div>
          <div v-else-if="scope.row.ExpectedInspectAt">
            {{ $sys.dateFormat(scope.row.ExpectedInspectAt, "Y-m-d H:i") }}
          </div>
          <div
            v-if="
              scope.row.ExpectedDealAt &&
              new Date(scope.row.ExpectedDealAt).getTime() <=
                new Date(new Date()).getTime() &&
              scope.row.DealStatus !== 6
            "
            style="color: red"
          >
            {{ $sys.dateFormat(scope.row.ExpectedDealAt, "Y-m-d H:i") }}
          </div>
          <div v-else-if="scope.row.ExpectedDealAt">
            {{ $sys.dateFormat(scope.row.ExpectedDealAt, "Y-m-d H:i") }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="更换方式" width="80">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.ReplacementMode === 0" type="warning">
            不更换
          </el-tag>
          <el-tag v-if="scope.row.ReplacementMode === 1" type="primary">
            更换配件
          </el-tag>
          <el-tag v-if="scope.row.ReplacementMode === 2" type="info">
            更换整机
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="DealPeople.Name" label="处理人" width="70" />
      <el-table-column prop="DealStatusName" label="维修状态" width="105">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.DealStatus === 0" type="warning">
            {{ scope.row.DealStatusName }}
          </el-tag>
          <el-tag v-else type="success">
            {{ scope.row.DealStatusName }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column width="180" label="操作">
        <template slot-scope="scope">
          <el-button
            type="button"
            @click.stop="onDetailItem(scope.row)"
            title="详情"
          >
            <i class="fas fa-eye"></i>
          </el-button>
          <el-button
            type="primary"
            @click.stop="onEditItem(scope.row)"
            title="编辑"
          >
            <i class="fas fa-pencil-alt"></i>
          </el-button>
          <el-button
            type="primary"
            @click.stop="onPrintItem(scope.row)"
            title="打印"
          >
            <i class="fa fa-print"></i>
          </el-button>
          <el-button
            type="danger"
            @click.stop="onDeleteItem(scope.row)"
            title="删除"
          >
            <i class="fas fa-trash-alt"></i>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="clearfix mar-top-10">
      <el-pagination
        class="pull-right"
        @current-change="onChangePage"
        layout="total, prev, pager, next"
        :total="pager.total"
        :current-page="pager.page"
        :page-size="pager.size"
      >
      </el-pagination>
    </div>

    <detail-form v-model="item" :visible.sync="deltailVisible" />
    <item-form
      v-model="item"
      :visible.sync="itemVisible"
      @form:saved="getItemList"
    />
  </el-card>
</template>

<script>
import ItemForm from "./form.vue";
import DetailForm from "./detail.vue";

export default {
  components: {
    ItemForm,
    DetailForm,
  },
  data() {
    return {
      itemList: [],
      loading: false,
      pager: {
        total: 0,
        page: 1,
        size: 15,
      },
      former: {
        Type: "",
        DealPeopleID: "",
        DealStatus: "",
      },
      key: "",
      item: this.getEmptyItem(),
      itemVisible: false,
      deltailVisible: false,
    };
  },
  mounted() {},
  created() {
    this.getItemList();
  },
  methods: {
    getItemList() {
      this.loading = true;
      this.$axios
        .get("dci/maintain/register", {
          params: {
            where: this.former,
            with: [
              "DciProduct.DciProductModel",
              "DciProduct.DciStation",
              "DciAccessory.DciAccessoryModel",
              "MaintainUser",
              "SendPeople",
              "DealPeople",
              // "DciSaleOrder",
            ],
            ...this.pager,
            key: this.key,
            order: ["deal_status", "-send_at"],
          },
        })
        .then((response) => {
          this.itemList = response.data.data;
          this.pager = _.pick(response.data, "size", "page", "total");
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onCreateItem() {
      this.item = this.getEmptyItem();
      this.itemVisible = true;
    },
    onDetailItem(row) {
      this.item = row;
      this.deltailVisible = true;
    },
    onEditItem(row) {
      this.item = row;
      this.itemVisible = true;
    },
    getEmptyItem() {
      return {
        ID: 0,
        Type: 0,
        SendPeopleID: this.$store.state.Auth.user.ID,
        SendAt: new Date(),
        TenseDays: 0,
        SendSource: "",
        ExpectedInspectAt: "",
        ExpectedDealAt: "",
        MalfunctionDesc: "",
      };
    },
    onSubmitQuery() {
      this.pager.page = 1;
      this.getItemList();
    },
    onChangePage(page) {
      this.pager.page = page;
      this.getItemList();
    },
    //打印维修处理单
    onPrintItem(row) {
      this.$axios
        .get(`dci/maintain/print/${row.ID}`, {
          responseType: "blob", //服务器响应的数据类型，可以是 'arraybuffer', 'blob', 'document', 'json', 'text', 'stream'，默认是'json'
        })
        .then((res) => {
          if (!res) {
            return;
          }
          const blob = new Blob([res.data], {
            type: "application/vnd.ms-excel",
          }); // 构造一个blob对象来处理数据，并设置文件类型

          let fName = "维修处理单";
          if (row.DciProduct !== null) {
            fName += "(" + row.DciProduct.SN + ")";
          } else if (row.DciAccessory !== null) {
            fName += "(" + row.DciAccessory.SN + ")";
          }
          fName += ".xlsx";

          if (window.navigator.msSaveOrOpenBlob) {
            //兼容IE10
            navigator.msSaveBlob(blob, fName);
          } else {
            const href = URL.createObjectURL(blob); //创建新的URL表示指定的blob对象
            const a = document.createElement("a"); //创建a标签
            a.style.display = "none";
            a.href = href; // 指定下载链接
            a.download = fName; //指定下载文件名
            a.click(); //触发下载
            URL.revokeObjectURL(a.href); //释放URL对象
          }
          // 这里也可以不创建a链接，直接window.open(href)也能下载
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onDeleteItem(row) {
      this.$confirm("确定要删除此维修信息吗？", "提示")
        .then(() => this.$axios.delete(`dci/maintain/register/${row.ID}`))
        .then(() => {
          this.getItemList();
          this.$message.success("删除成功");
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        });
    },
    onShowSaleOrder(row){
        window.open(row.AmbSaleOrderUrl, "_blank");
    },
    //打印维修报价单【暂不启用】
    // onPrintSaleOrder(row) {
    //   this.$axios
    //     .get(`dci/maintain/sale/print/${row.DciSaleOrderID}`, {
    //       responseType: "blob", //服务器响应的数据类型，可以是 'arraybuffer', 'blob', 'document', 'json', 'text', 'stream'，默认是'json'
    //     })
    //     .then((res) => {
    //       if (!res) {
    //         return;
    //       }
    //       const blob = new Blob([res.data], {
    //         type: "application/vnd.ms-excel",
    //       }); // 构造一个blob对象来处理数据，并设置文件类型

    //       let fName = "维修报价单";
    //       if (row.DciSaleOrder.Code !== "") {
    //         fName += "(" + row.DciSaleOrder.Code + ")";
    //       }
    //       fName += ".xlsx";

    //       if (window.navigator.msSaveOrOpenBlob) {
    //         //兼容IE10
    //         navigator.msSaveBlob(blob, fName);
    //       } else {
    //         const href = URL.createObjectURL(blob); //创建新的URL表示指定的blob对象
    //         const a = document.createElement("a"); //创建a标签
    //         a.style.display = "none";
    //         a.href = href; // 指定下载链接
    //         a.download = fName; //指定下载文件名
    //         a.click(); //触发下载
    //         URL.revokeObjectURL(a.href); //释放URL对象
    //       }
    //       // 这里也可以不创建a链接，直接window.open(href)也能下载
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //     });
    // },
  },
};
</script>

